import { css } from '@microsoft/fast-element';
import { MatchMediaStyleSheetBehavior } from '@microsoft/fast-foundation';
import { darkModeQuery, lightModeQuery } from '../../style.js';
import { cornerRadiusLayer } from '@adaptive-web/adaptive-ui/reference';
import { typeRampStyles } from '../../type-ramp.js';

const svgStyles = css`
	svg {
		display: flex;
		flex: 1 1 auto;
		box-sizing: border-box;
		pointer-events: all;
	}

	svg :is(.rest, .hover, .active) {
		transition: opacity 400ms ease;
	}

	[id^="arm-"] {
		cursor: pointer;
	}

	#arm-1 {
		&:not(.hover, .active) {
			& .hover, & .active {
				opacity: 0;
			}
		}

		&.hover {
			& .rest, & .active {
				opacity: 0;
			}

			& .hover {
				opacity: 1;
			}
		}

		&.active {
			& .rest, & .hover {
				opacity: 0;
			}

			& .active {
				opacity: 1;
			}
		}
	}

	#arm-2 {
		&:not(.hover, .active) {
			& .hover, & .active {
				opacity: 0;
			}
		}

		&.hover {
			& .rest, & .active {
				opacity: 0;
			}

			& .hover {
				opacity: 1;
			}
		}

		&.active {
			& .rest, & .hover {
				opacity: 0;
			}

			& .active {
				opacity: 1;
			}
		}
	}

	#arm-3 {
		&:not(.hover, .active) {
			& .hover, & .active {
				opacity: 0;
			}
		}

		&.hover {
			& .rest, & .active {
				opacity: 0;
			}

			& .hover {
				opacity: 1;
			}
		}

		&.active {
			& .rest, & .hover {
				opacity: 0;
			}

			& .active {
				opacity: 1;
			}
		}
	}

	#arm-4 {
		&:not(.hover, .active) {
			& .hover, & .active {
				opacity: 0;
			}
		}

		&.hover {
			& .rest, & .active {
				opacity: 0;
			}

			& .hover {
				opacity: 1;
			}
		}

		&.active {
			& .rest, & .hover {
				opacity: 0;
			}

			& .active {
				opacity: 1;
			}
		}
	}

	#arm-5 {
		&:not(.hover, .active) {
			& .hover, & .active {
				opacity: 0;
			}
		}

		&.hover {
			& .rest, & .active {
				opacity: 0;
			}

			& .hover {
				opacity: 1;
			}
		}

		&.active {
			& .rest, & .hover {
				opacity: 0;
			}

			& .active {
				opacity: 1;
			}
		}
	}

	#arm-6 {
		&:not(.hover, .active) {
			& .hover, & .active {
				opacity: 0;
			}
		}

		&.hover {
			& .rest, & .active {
				opacity: 0;
			}

			& .hover {
				opacity: 1;
			}
		}

		&.active {
			& .rest, & .hover {
				opacity: 0;
			}

			& .active {
				opacity: 1;
			}
		}
	}
`;

export default css`
	${svgStyles}
	${typeRampStyles}

	:host {
		display: grid;
		gap: var(--padding-md);
	}

	b {
		font-variation-settings: 'wght' 600;
		font-size: 16px;
	}

	p {
		--font-size: 14px;
	}
	
	a {
    color: #537494;

		&:hover {
			text-decoration: none;
		}

    &:visited {
      color: #537494;
    }
  }

	.image-container {
		display: flex;
		contain: content;
		border-radius: ${cornerRadiusLayer};
		align-self: flex-start;
		width: 100%;
	}
`.withBehaviors(
	new MatchMediaStyleSheetBehavior(
		lightModeQuery,
		css`
			[expanded] .highlighted {
				color: var(--secondary-color);
			}
		`
	),
	new MatchMediaStyleSheetBehavior(
		darkModeQuery,
		css`
			[expanded] .highlighted {
				color: var(--secondary-color);
			}

			a {
				color: #bddeff;

				&:visited {
					color: #bddeff;
				}
			}
		`
	),
	new MatchMediaStyleSheetBehavior(
		window.matchMedia('(min-width: 660px)'),
		css`
			:host {
				display: flex;
				flex-direction: column;
			}
		`
	),
	new MatchMediaStyleSheetBehavior(
		window.matchMedia('(min-width: 890px)'),
		css`
			:host {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
			}
		`
	)
);